import { useState, useEffect } from 'react';
import {
    getProductExternalById,
    getProductsExternal
} from '../services/ProductExternalService';

export const useProductExternal = () => {

    const [productExternal, setProductExternal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProductExternal = async () => {
        setLoading(true);
        try {
            const response = await getProductsExternal();
            setProductExternal(response.data);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    const fetchProductExternalById = async (id) => {
        setLoading(true);
        try {
            const response = await getProductExternalById(id);
            setProductExternal(response.data);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProductExternal();
    }, [productExternal]);

    // console.log(productExternal)

    return { productExternal, loading, error, fetchProductExternalById, fetchProductExternal };

};
